import { Component, ViewEncapsulation, Inject } from '@angular/core';
import { ComponentModalBase } from '@framework/base/component';
import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import * as _ from 'lodash';
import { BehaviorSubject } from 'rxjs';
import { Router } from '@angular/router';
import { environment } from '@app/env/environment';
import { debounceTime } from 'rxjs/operators';
import { RssFeedHttpService } from '@modules/company/services/rss-feed.http-service';
import { ToastService } from '@framework/services';

@Component({
  selector: 'copy-embed-embed-modal-container',
  templateUrl: './copy-embed-modal-container.component.html',
  styleUrls: ['./copy-embed-modal-container.component.scss'],
})

export class CopyEmbedVideoModalContainerComponent extends ComponentModalBase<any> {

  public embedForm: UntypedFormGroup;
  public copyForm: UntypedFormGroup;
  public IsScriptCreated: boolean = false;
  public showPreview: boolean = false;
  public baseUrl: string;
  public queryData: any;
  public videoUrl:any;
  public videoPayload:any[] = [];
  public thumbnailUrl:any;
  public activeTab: string;
  private rssToken: string;

  constructor(
    private formBuilder: UntypedFormBuilder,
    private router: Router,
    private rssFeedHttpService: RssFeedHttpService,
    private toastService: ToastService
  ) {
    super();
    this.initForm();

  }

  // Life cycle hook
  protected onInit(): void {
    this.copyForm.patchValue({
      embedbodyCode: this.initialState.videoUrl,
    })
    this.copyForm.controls.styledbodyCode.setValue(`.iframe-wrapper {
            width: 100%;
            min-width: 1000px; /* Minimum width to prevent content squeezing */
            max-width: 1400px; /* Maximum width for very large screens */
            margin: 0 auto;
            height: 1200px; /* Fixed height, adjust as needed */
            background: #ffffff;
            box-shadow: 0 2px 8px rgba(0,0,0,0.1);
            border-radius: 8px;
            overflow: hidden;
        }

        .iframe-wrapper iframe {
            border: none;
            display: block;
        }

        /* For tablets - maintain minimum width but allow scrolling */
        @media (max-width: 1024px) {
            .iframe-container {
                padding: 15px;
            }
            
            .iframe-wrapper {
                min-width: 1000px; /* Keep minimum width */
                height: 1100px;
            }
        }

        /* For mobile - keep minimum width and enable horizontal scroll */
        @media (max-width: 768px) {
            .iframe-container {
                padding: 10px;
            }
            
            .iframe-wrapper {
                min-width: 1000px; /* Maintain minimum width */
                height: 1000px;
                border-radius: 4px;
            }
            
            /* Add scroll hint */
            .iframe-container::before {
                content: "← Scroll to view full content →";
                display: block;
                text-align: center;
                padding: 10px;
                background: #2196F3;
                color: white;
                font-size: 12px;
                border-radius: 4px;
                margin-bottom: 10px;
            }
        }

        /* Alternative: Full-width mobile approach (optional) */
        @media (max-width: 480px) {
            .iframe-wrapper {
                height: 900px;
            }
        }

        /* Loading state */
        .iframe-wrapper::after {
            content: "Loading...";
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            color: #666;
            font-size: 18px;
            pointer-events: none;
        }

        .iframe-wrapper iframe {
            position: relative;
            z-index: 1;
            background: white;
        } `)

if(this.initialState.isvideo){
   var vido =   this.initialState.videoUrl.map((item,i)=>{
       let name = i+1
    return {
      name:'Video'+name,
      token: item.source,
      thumbnail_url:item.thumbnail_url
    }
   })

   this.videoPayload = vido;
   this.copyForm.controls.videourl.setValue(this.videoPayload[0].token)
   this.videoUrl = window.location.origin+'/embed/video/'+this.videoPayload[0].token+'/'+this.initialState.story_id;
   this.thumbnailUrl =this.videoPayload[0].thumbnail_url ? this.videoPayload[0].thumbnail_url : 'https://image.mux.com/'+this.videoPayload[0].token+'/thumbnail.jpg'

}

    // this.embedForm.valueChanges.pipe(debounceTime(500)).subscribe(() => {
    //   this.showPreview = false;
    //   this.loadScript();
    // })
  }
  protected onDestroy(): void {
  }
  protected onChanges(): void {

  }
  protected onDoCheck(): void {

  }
  protected onAfterContentInit(): void {

  }
  protected onAfterContentChecked(): void {

  }
  protected onAfterViewInit(): void {
    // this.loadScript();
  }
  protected onAfterViewChecked(): void {

  }

  private initForm() {
    this.copyForm = this.formBuilder.group({
      height: [400, Validators.required],
      width: [400, Validators.required],
      storyheight: [400, Validators.required],
      storywidth: [400, Validators.required],
      widthList: ['px'],
      heightList: ['px'],
      storywidthList: ['px'],
      storyheightList: ['px'],
      videourl:['Video 1'],
      bodyCode: [{ value: '', disabled: true }],
      storybodyCode: [{ value: '', disabled: true }],
      framebodyCode: [{ value: '', disabled: true }],
      embedbodyCode: [{ value: '', disabled: true }],
      styledbodyCode: [{ value: '', disabled: true }],
    });



    // this.copyForm = this.formBuilder.group({
    //   height: [900, Validators.required],
    //   width: [100, Validators.required],
    //   widthList:['px'],
    //   heightList:['px'],
    //   bodyCode: [{ value: '', disabled: true }],
    //   selectCheckbox: ['public', Validators.required],
    //   selectRadio: [false, Validators.required]
    // })


    // this.copyForm = this.formBuilder.group({
    //  value:[{ value: '', disabled: true }],
    //  publicValue:[{ value: '', disabled: true }]
    // })

  }

  get updatedIframeCode() {
    if(this.initialState.isvideo){
      var iframeContext = `<div class="container"> <iframe class="responsive-iframe" src="${this.videoUrl}"`
      iframeContext += ' height="' + this.copyForm.value.height + this.getHeight() + '"' + ' width="' + this.copyForm.value.width + this.getwidth() + '"';
      iframeContext += ' frameborder="0"' + "></iframe></div>";
      this.copyForm.controls.bodyCode.setValue(iframeContext)

      var storyiframeContext = `<div class="iframe-container"> <div class="iframe-wrapper"> <iframe src="${this.initialState.storyUrl}"`
      storyiframeContext += ' height="' + this.copyForm.value.storyheight + this.getStoryHeight() + '"' + ' width="' + this.copyForm.value.storywidth + this.getStorywidth() + '"';
      storyiframeContext += ' frameborder="0"' + "></iframe></div></div>";
      this.copyForm.controls.storybodyCode.setValue(storyiframeContext)
   
    }else{
      var storyiframeContext = `<div class="iframe-container"> <div class="iframe-wrapper"> <iframe src="${this.initialState.storyUrl}"`
      storyiframeContext += ' height="' + this.copyForm.value.storyheight + this.getStoryHeight() + '"' + ' width="' + this.copyForm.value.storywidth + this.getStorywidth() + '"';
      storyiframeContext += ' frameborder="0"' + "></iframe></div></div>";
      this.copyForm.controls.storybodyCode.setValue(storyiframeContext)
    }

   

    return;
  }
  getHeight() {
    if (+this.copyForm.value.height > 100 && this.copyForm.value.heightList == '%') {
      this.copyForm.controls.height.setValue(100);
      return this.copyForm.value.heightList
    }
    else {
      return this.copyForm.value.heightList
    }
  }
  getwidth() {
    if (+this.copyForm.value.width > 100 && this.copyForm.value.widthList == '%') {
      this.copyForm.controls.width.setValue(100);
      return this.copyForm.value.widthList
    }
    else {
      return this.copyForm.value.widthList
    }
  }


  getStoryHeight() {
    if (+this.copyForm.value.storyheight > 100 && this.copyForm.value.heightList == '%') {
      this.copyForm.controls.storyheight.setValue(100);
      return this.copyForm.value.storyheightList
    }
    else {
      return this.copyForm.value.storyheightList
    }
  }

  copyvideoLink(){
    const selBox = document.createElement('textarea');
    selBox.style.position = 'fixed';
    selBox.style.left = '0';
    selBox.style.top = '0';
    selBox.style.opacity = '0';
    selBox.value = this.videoUrl.toString();
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);
    this.toastService.success("Copied");
  }
  getStorywidth() {
    if (+this.copyForm.value.storywidth > 100 && this.copyForm.value.storywidthList == '%') {
      this.copyForm.controls.storywidth.setValue(100);
      return this.copyForm.value.storywidthList
    }
    else {
      return this.copyForm.value.storywidthList
    }
  }

  changevideo(data){
    if(typeof data === 'string' ){
       this.videoUrl = window.location.origin+'/embed/video/'+data+'/'+this.initialState.story_id;;
       var thumbnailUrl =this.videoPayload.find(item => item.token == data)?.thumbnail_url
       this.thumbnailUrl = thumbnailUrl  ?  thumbnailUrl  : 'https://image.mux.com/'+data+'/thumbnail.jpg'
    }
  }

  copyLink(){
    const selBox = document.createElement('textarea');
    selBox.style.position = 'fixed';
    selBox.style.left = '0';
    selBox.style.top = '0';
    selBox.style.opacity = '0';
    selBox.value = this.videoUrl.toString();
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);
    this.toastService.success("Copied");
  }

  

  public close() {
    this.onClose.emit();
  }


}
